module.exports = __webpack_public_path__ + "img/yijian-gaoji.a778954f.png";